import React from 'react';
import { Typography } from 'antd';

const { Title } = Typography;

const PageTitleHook = props => {
    // Check if the title is a complex element (like a div with flex layout)
    const isComplexTitle = React.isValidElement(props.title) && props.title.type === 'div';
    
    return(
      <div style={{
        ...props.style,
        padding: isComplexTitle ? '16px 0' : '32px 0',
        marginBottom: '32px',
        position: 'relative',
        textAlign: isComplexTitle ? 'left' : 'center',
        overflow: 'hidden',
      }}>
        {/* Animated background elements - only for simple titles */}
        {!isComplexTitle && (
          <>
            <div style={{
              position: 'absolute',
              top: '-50px',
              left: '-50px',
              width: '100px',
              height: '100px',
              background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
              borderRadius: '50%',
              animation: 'float 6s ease-in-out infinite',
            }} />
            <div style={{
              position: 'absolute',
              bottom: '-30px',
              right: '-30px',
              width: '60px',
              height: '60px',
              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%)',
              borderRadius: '50%',
              animation: 'float 4s ease-in-out infinite reverse',
            }} />
          </>
        )}
        
        {isComplexTitle ? (
          <div style={{
            margin: 0,
            position: 'relative',
            width: '100%',
          }}>
            {props.title}
          </div>
        ) : (
          <Title 
            level={2} 
            style={{
              margin: 0,
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontSize: '32px',
              fontWeight: 800,
              lineHeight: 1.1,
              position: 'relative',
              display: 'inline-block',
              letterSpacing: '-1px',
              textShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              filter: 'drop-shadow(0 2px 4px rgba(102, 126, 234, 0.3))',
            }}
          >
            {props.title}
          </Title>
        )}
        
        {/* Enhanced decorative elements - only for simple titles */}
        {!isComplexTitle && (
          <>
            <div style={{
              position: 'absolute',
              bottom: '12px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '80px',
              height: '4px',
              background: 'linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
              borderRadius: '2px',
              opacity: 0.8,
              boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
            }} />
            
            {/* Additional accent dots */}
            <div style={{
              position: 'absolute',
              bottom: '8px',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              gap: '8px',
            }}>
              <div style={{
                width: '6px',
                height: '6px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: '50%',
                opacity: 0.6,
              }} />
              <div style={{
                width: '4px',
                height: '4px',
                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                borderRadius: '50%',
                opacity: 0.8,
              }} />
              <div style={{
                width: '6px',
                height: '6px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: '50%',
                opacity: 0.6,
              }} />
            </div>
          </>
        )}
        
        {/* Enhanced background glow - only for simple titles */}
        {!isComplexTitle && (
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '300px',
            height: '300px',
            background: 'radial-gradient(circle, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.04) 50%, transparent 70%)',
            borderRadius: '50%',
            zIndex: -1,
            filter: 'blur(1px)',
          }} />
        )}
        
        {/* CSS Animations */}
        <style jsx>{`
          @keyframes float {
            0%, 100% {
              transform: translateY(0px) rotate(0deg);
            }
            50% {
              transform: translateY(-10px) rotate(180deg);
            }
          }
        `}</style>
      </div>
    )
}

export default PageTitleHook;